import { connect } from 'react-redux';
import {
  API_INITIATE_ARTICLES,
  API_COMPLETE_ARTICLES,
  API_INITIATE_MARKET_COMPARISON,
  API_COMPLETE_MARKET_COMPARISON,
  API_INITIATE_PRODUCT_RECOMMENDATION,
  API_COMPLETE_PRODUCT_RECOMMENDATION,
  UPDATE_PRODUCT_RECOMMENDATION,
  UPDATE_ALL_PRODUCT_RECOMMENDATION,
  MARKET_COMPARISON_INITIAL_PRODUCT_COUNT,
  IMAGE_BASE_LINK,
  RESET_PRODUCT_RECOMMENDATIONS,
} from '../../app-constants';
import View from './homepage.presenter';
import { getTotalBenefits } from '../market-comparison/market-comparison.actions';

// Reducer
export const homePageReducer = (state = {
  loading: false,
  articles: [],
  marketComparison: [],
  productRecommendation: [],
  showDownloadLoader: false,
  aeDetails: {},
  totalBenefits: 0,
}, action) => {
  switch (action.type) {
    case API_INITIATE_ARTICLES:
      return { ...state, loading: true };
    case API_INITIATE_MARKET_COMPARISON:
      return { ...state, loading: true };
    case API_COMPLETE_ARTICLES: {
      return { ...state, loading: false, articles: action.data };
    }
    case API_COMPLETE_MARKET_COMPARISON: {
      return { ...state, loading: false, marketComparison: action.data };
    }
    case API_INITIATE_PRODUCT_RECOMMENDATION:
      return { ...state, loading: true };
    case API_COMPLETE_PRODUCT_RECOMMENDATION:
      return { ...state, loading: false, productRecommendation: action.data };
    case UPDATE_PRODUCT_RECOMMENDATION:
      return {
        ...state,
        productRecommendation: state.productRecommendation.map(product => ({
          ...product,
          recommendationSelected:
          /* update only for matching product id */
              (product.recommendedProductCode === action.checkBoxState.id)
                ? action.checkBoxState.checked
                : product.recommendationSelected,
        })),
      };
    case RESET_PRODUCT_RECOMMENDATIONS:
      return {
        ...state,
        productRecommendation: state.productRecommendation.map(product => ({
          ...product,
          recommendationSelected: false,
        })),
      };
    case UPDATE_ALL_PRODUCT_RECOMMENDATION:
      return {
        ...state,
        productRecommendation: state.productRecommendation.map((product, index) => ({
          ...product,
          recommendationSelected:
          /* update only first five if select all false
             only applicable for product recommendation selectAll */
              (!action.viewAll && index >= MARKET_COMPARISON_INITIAL_PRODUCT_COUNT)
                ? product.recommendationSelected
                : action.checkBoxState.checked,
        })),
      };
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  articles: state.homePageReducer.articles,
  marketComparison: state.homePageReducer.marketComparison,
  authorableContent: state.authorableContentReducer.authorableContent.homePage,
  graphAuthorableContent: state.authorableContentReducer.authorableContent.marketComparison.graphContent,
  totalBenefits: getTotalBenefits(state.homePageReducer.productRecommendation),
  authentication: state.dataBootStrapReducer.authentication,
  productRecommendation: state.homePageReducer.productRecommendation,
  imageBaseLink: IMAGE_BASE_LINK,
  currentBusinessCase: state.businessCaseReducer.currentBusinessCase,
  bcbCasesList: state.businessCaseReducer.businessCaseList,
});

const HomePage = connect(
  mapStateToProps,
)(View);


export default HomePage;
